import React from 'react'
import styles from './sectionHeading.module.scss'

type SectionHeadingProps = {
  text: string
  afterTitle?: string
  color?: string
}

function SectionHeading({ text, afterTitle, color }: SectionHeadingProps) {
  return (
    <div
      className={styles.sectionHeading_wrapper}
      style={{ borderBottomColor: color }}>
      <div
        className={styles.vertical_bar}
        style={{ backgroundColor: color }}></div>
      <div className={styles.header_container}>
        <h2 className={styles.header_text}>
          {text}
          {afterTitle && (
            <span className={styles.after_title}>{afterTitle}</span>
          )}
        </h2>
      </div>
    </div>
  )
}

export default SectionHeading
